export const boundedGalleryIndex = (index, count) => Math.max(0, Math.min(Math.max(0, count - 1), Number.isFinite(index) ? Math.round(index) : 0));
export const nearestGalleryIndex = (positions, scrollLeft) => {
  if (!positions.length) return 0;
  return positions.reduce((nearest, value, index) => Math.abs(value - scrollLeft) < Math.abs(positions[nearest] - scrollLeft) ? index : nearest, 0);
};

export function initializeGallery(gallery) {
  if (gallery.dataset.hlGalleryReady) return;
  const track = gallery.querySelector('[data-hl-gallery-track]');
  const slides = [...gallery.querySelectorAll('[data-hl-gallery-slide]')];
  if (!track || !slides.length) return;
  gallery.dataset.hlGalleryReady = 'true';
  const links = [...gallery.querySelectorAll('[data-hl-gallery-link]')];
  const steps = [...gallery.querySelectorAll('[data-hl-gallery-step]')];
  const status = gallery.querySelector('[data-hl-gallery-status]');
  let current = 0;
  let frame = 0;
  const positions = () => slides.map(slide => Math.abs(slide.offsetLeft - slides[0].offsetLeft));
  const update = () => {
    current = nearestGalleryIndex(positions(), Math.abs(track.scrollLeft));
    links.forEach((link, index) => index === current ? link.setAttribute('aria-current', 'true') : link.removeAttribute('aria-current'));
    steps.forEach(button => { button.disabled = Number(button.dataset.hlGalleryStep) < 0 ? current === 0 : current === slides.length - 1; });
    if (status) status.textContent = status.dataset.hlGalleryTemplate.replace('__CURRENT__', String(current + 1));
  };
  const go = index => {
    const destination = boundedGalleryIndex(index, slides.length);
    const reduced = globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const direction = globalThis.getComputedStyle?.(track).direction === 'rtl' ? -1 : 1;
    track.scrollTo({ left: direction * positions()[destination], behavior: reduced ? 'auto' : 'smooth' });
  };
  steps.forEach(button => { button.hidden = false; button.addEventListener('click', () => go(current + Number(button.dataset.hlGalleryStep))); });
  links.forEach((link, index) => link.addEventListener('click', event => { event.preventDefault(); go(index); }));
  track.addEventListener('scroll', () => { if (frame) return; frame = requestAnimationFrame(() => { frame = 0; update(); }); }, { passive: true });
  track.addEventListener('keydown', event => {
    if (event.target !== track) return;
    const direction = globalThis.getComputedStyle?.(track).direction === 'rtl' ? -1 : 1;
    const destination = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : event.key === 'ArrowRight' ? current + direction : event.key === 'ArrowLeft' ? current - direction : null;
    if (destination === null) return;
    event.preventDefault(); go(destination);
  });
  globalThis.addEventListener?.('resize', update);
  update();
}

if (typeof document !== 'undefined') {
  const initialize = () => document.querySelectorAll('[data-hl-gallery]').forEach(initializeGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  document.addEventListener('shopify:section:load', initialize);
}
